import OfficeSchedulingPage from './OfficeSchedulingPageWithData';

export default OfficeSchedulingPage;
